import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const servicesColumns: GridColumnConfig[] = [
  {
    title: 'Sort Order',
    field: 'sortOrder',
    filter: 'numeric',
    width: '130',
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  // {
  //   title: 'Service Code',
  //   field: 'serviceCode',
  //   filter: 'text',
  //   searchable: true,
  //   width: '220',
  // },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Service Group',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
    width: '190',
  },
  // {
  //   title: 'Forecast Days',
  //   field: 'forecastDays',
  //   filter: 'text',
  // },
  // {
  //   title: 'Invoice Amount Service($)',
  //   field: 'price',
  //   filter: 'text',
  //   fieldType: 'currency',
  // },
  // {
  //   title: 'Invoice Amount Retest($)',
  //   field: 'invoiceRetestAmount',
  //   filter: 'text',
  //   fieldType: 'currency',
  // },
  // {
  //   title: 'Accrual Amount Service($)',
  //   field: 'accrualAmount',
  //   filter: 'text',
  //   fieldType: 'currency',
  // },
  // {
  //   title: 'Accrual Amount Retest($)',
  //   field: 'accrualRetestAmount',
  //   filter: 'text',
  //   fieldType: 'currency',
  // },
  {
    title: 'Invoice Amount ($)', // Main header
    field: '', // No specific field for the group
    isHideColumnMenu: true, // Disable column menu for the main header
    filter: 'text', // Disable column menu for the main header
    children: [
      {
        title: 'Service',
        field: 'price',
        filter: 'text',
        fieldType: 'currency',
      },
      {
        title: 'Retest',
        field: 'invoiceRetestAmount',
        filter: 'text',
        fieldType: 'currency',
      },
    ],
  },
  {
    title: 'Accrual Amount ($)', // Main header for accrual
    field: '', // No specific field for the group
    isHideColumnMenu: true, // Disable column menu for the main header
    filter: 'text',
    children: [
      {
        title: 'Service',
        field: 'accrualAmount',
        filter: 'text',
        fieldType: 'currency',
      },
      {
        title: 'Retest',
        field: 'accrualRetestAmount',
        filter: 'text',
        fieldType: 'currency',
      },
    ],
  },
];
